// extracted by css-extract-rspack-plugin
var _1 = "draggable-table_row_dragging__uf1O0";
export { _1 as "row_dragging" }
